// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"48a311c1","217":"57c6ba3d","431":"48a311c1","585":"48a311c1","641":"0e6aca7a","749":"0e6aca7a"}[chunkId] + ".chunk.css";
};